import localforage from "localforage";
const useLocalStorage = () => {
  const setData = (key: string, data: any) => {
    localStorage.setItem(key, JSON.stringify(data));
    return data;
  };

  const getData = (key: string) => {
    const value = localStorage.getItem(key);
    if (value === null) {
      return null;
    }
    return JSON.parse(value);
  };

  const clear = () => {
    localStorage.clear();
    localforage.clear();
  };
  return { getData, setData, clear };
};

export default useLocalStorage;
